import { render, staticRenderFns } from "./RouletteCanvas.vue?vue&type=template&id=05b87b0e"
import script from "./RouletteCanvas.vue?vue&type=script&lang=js"
export * from "./RouletteCanvas.vue?vue&type=script&lang=js"
import style0 from "@/assets/Roulette/css/GB-canvas-turntable.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RouletteCanvas.vue?vue&type=style&index=1&id=05b87b0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports